const styles = theme => ({
  loader: {
    "padding-top": "32px",
  },
  wrapper: {
    "padding-top": theme.spacing(1),
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  logoImage: {
    width: "80%",
  },
})

export default styles
